import React from "react";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { faTimes } from "@fortawesome/free-solid-svg-icons";
//import logo from "../../images/logo.png";

const AddCard = ({ isOpen, setIsAddModalOpen, children }) => {
  if (!isOpen) return null;

  /* const handleClose = () => {
    setIsAddModalOpen(false);
  }; */

  return (
    <div className=" z-50 fixed inset-0 overflow-y-auto">
      {/* Black Background Overlay */}
      <div className="absolute inset-0 bg-gray-500 opacity-75 z-40"></div>

      {/* Modal Content */}
      <div className="fixed z-50 inset-0 flex items-center justify-center">
        <div className="bg-white rounded-lg w-full shadow-xl max-w-lg mx-auto p-6">
          <div className="flex justify-center items-center mb-4">
            <img src={"/qushi_logo.png"} alt="Logo" className="h-16 w-auto" />
          </div>

          <h2 className="text-center w-full text-lg font-bold text-primaryColor mb-4">Add Card</h2>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AddCard;
